import { removeStoreAll } from "@/utils/storage";
export default {
  data() {
    return {};
  },
  created() {
    this.onSplashLoad();
  },
  methods: {
    onSplashLoad() {
      removeStoreAll();
      setTimeout(() => {
        this.$router.replace({
          path: '/home'
        });
      }, 1000);
    }
  }
};